import http from './ajax';

const API_URL = {
  newsUrl: '/News',
  BannersUrl: '/Banners',
};

class NewsApi extends http {
  // eslint-disable-next-line no-unused-vars
  getAllNews = async (params) => {
    const url = `${API_URL.newsUrl}/List?count=10&leaf=${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getIndexNews = async (params) => {
    const url = `${API_URL.newsUrl}/List?count=4&leaf=1`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getNewsCategories = async (params) => {
    const url = `${API_URL.newsUrl}/Categories`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getNewsDetail = async (params) => {
    const url = `${API_URL.newsUrl}/${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getNewsDetailFilter = async (params) => {
    const url = `${API_URL.newsUrl}/List/${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getBanners = async (params) => {
    const url = `${API_URL.BannersUrl}?count=10&leaf=${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }
}

export default new NewsApi();
